export default "__VITE_ASSET__5b0121e4__"